import styled from 'styled-components';

const Wrapper = styled.i`
  display: inline-flex;
`;

export default {
  Wrapper,
};
